import * as React from "react";
import { useMemo, useCallback } from "react";
import { ReadOnlyFormGroup } from "components/common";
import { usePagination } from "common/contexts";
import {
  useGetInvestigations,
  useGetUsers,
  useGetTeams,
  useGetPriorities
} from "security-app/hooks/useInvestigationsAPI";
function CreateInvestigationNotificationDetails({
  notification
}) {
  var _a, _b;
  const localPagination = usePagination();
  const { investigations } = useGetInvestigations(localPagination);
  const investigationsMap = useMemo(
    () => Object.fromEntries(investigations.map((investigation) => [investigation.id, { label: investigation.name }])),
    [investigations]
  );
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const usersTeamsMap = useMemo(
    () => ({
      ...Object.fromEntries(users.map((user) => [user.id, { label: user.full_name, icon: "user" }])),
      ...Object.fromEntries(teams.map((team) => [team.id, { label: team.name, icon: "users" }]))
    }),
    [users, teams]
  );
  const { priorities } = useGetPriorities(true);
  const getPriorityText = useCallback(
    (value) => {
      var _a2;
      return value ? (_a2 = priorities.find((priority) => priority.priority === value)) == null ? void 0 : _a2.text : "";
    },
    [priorities]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Create a New Investigation for Every Alert",
      value: notification.config.create_new_investigation ? /* @__PURE__ */ React.createElement("em", null, "True") : /* @__PURE__ */ React.createElement("em", null, "False")
    }
  ), !notification.config.create_new_investigation && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Investigation",
      value: (_a = investigationsMap[notification.config.investigation_id]) == null ? void 0 : _a.label
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Assign Investigation To",
      value: (_b = usersTeamsMap[notification.config.investigation_assigned_to]) == null ? void 0 : _b.label
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Investigation Priority",
      value: getPriorityText(notification.config.investigation_priority)
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Investigation Status", value: notification.config.investigation_status }));
}
export default CreateInvestigationNotificationDetails;
